var base = require('navbar/navbar');

Vue.component('spark-navbar', {
    mixins: [base],

    data() {
        return {
            expanded: false,
        }
    },

    methods: {
        toggleExpanded() {
            setTimeout(() => this.expanded = !this.expanded, 100);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/navbar/navbar.js